import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	image: {
		marginBottom: theme.spacing(2)
	},
	name: {
		marginBottom: theme.spacing(1.5)
	},
	mail: {
		display: "tabel",
		"& a": {
			alignItems: "center",
			color: theme.palette.text.primary,
			display: "inline-flex",
			fontSize: 14,
			gap: theme.spacing(1),
			padding: theme.spacing(0.5, 0),
			transition: theme.transitions.create(["color"], {
				duration: theme.transitions.duration.short
			}),
			"& span": {
				lineHeight: 1.05,
				wordBreak: "break-all"
			},
			"&:hover": {
				color: theme.palette.primary.main
			},
			[theme.breakpoints.up("sm")]: {
				fontSize: 16
			}
		}
	}
}));

export default styles;
